// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sGUn","badges":"styles_badges__H__jF"};